import { render, staticRenderFns } from "./FeatureCapability.vue?vue&type=template&id=ddc7479a"
import script from "./FeatureCapability.vue?vue&type=script&lang=js"
export * from "./FeatureCapability.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports